module.exports = __webpack_public_path__ + "img/oficinas.cff57afd.png";